import React from "react";
import { Checkbox, FormControlLabel, FormHelperText, Link } from "@mui/material";

const Terms = ({ checkedTerms, termsError, handleTermsChange }) => (
    <>
        <FormControlLabel
            control={<Checkbox checked={checkedTerms} onChange={handleTermsChange} size="small" />}
            label={<p style={{ fontSize: "12px" }}>Accept all</p>}
            style={{ marginLeft: "-10px", marginRight: "6px" }}
        />
        <Link
            style={{ fontSize: "12px" }}
            href="https://adadot.com/terms.html"
            target="_blank"
            rel="noopener"
            underline="hover"
        >
            Terms & Conditions
        </Link>
        {termsError && (
            <FormHelperText error>Terms agreement is required to integrate</FormHelperText>
        )}
    </>
);

export default Terms;
